<h2 class="ui icon header w-full">
    <i class="circular industry icon"
       style="color: silver;"></i>
    <div class="content">
        Firma Ekle
        <div class="sub header">
            Sisteminize Yeni Bir Firma Ekleyebilirsiniz
        </div>
    </div>
</h2>
<fikoyt-parametreler #parametrelerBilesen
                     [parametreler]="parametreler"></fikoyt-parametreler>

<div style="display: flex;align-items: end;flex-direction:row;">
    <button nz-button
            nz-wave
            nzSize="small"
            nzType="primary"
            style="margin-top: 0.5em;"
            nzDanger
            (click)="nzModalRef?.close();rota.set('ana-sayfa');CD.detectChanges();">
        <i class="door closed icon"></i>
        İptal
    </button>
    <span style="flex: 1;"></span>
    <button nz-button
            #gonderButton
            nz-wave
            nzSize="small"
            nzType="primary"
            style="margin-top: 0.5em;"
            >
        <i class="icon"
           [@imageChange]="ekleIstek.mesgul || ekleIstek.mesgul ? 'hidden' : 'visible'"
           [class.asterisk]="ekleIstek.mesgul"
           [class.loading]="ekleIstek.mesgul"
           [class.send]="!ekleIstek.mesgul"></i>
        Gönder
    </button>
</div>